import { useState, useRef } from "react";
import { SessionInfo, YearData } from "../../../api/models";

/**
 * Custom hook for managing session-related state
 */
export const useSessionState = () => {
    const [todaySessionsRef, setTodaySessionsRef] = useState<SessionInfo[]>([]);
    const [last7SessionsRef, setLast7SessionsRef] = useState<SessionInfo[]>([]);
    const [last30SessionsRef, setLast30SessionsRef] = useState<SessionInfo[]>([]);
    const [monthlySessions, setMonthlySessions] = useState<YearData[]>([]);
    const [nextDateToLoad, setNextDateToLoad] = useState<string>("");
    const [searchTerm, setSearchTerm] = useState("");

    // Backup states for search functionality
    const [backupTodaySessions, setBackupTodaySessions] = useState<SessionInfo[]>([]);
    const [backupLast7Sessions, setBackupLast7Sessions] = useState<SessionInfo[]>([]);
    const [backupLast30Sessions, setBackupLast30Sessions] = useState<SessionInfo[]>([]);
    const [backupMonthlySessions, setBackupMonthlySessions] = useState<YearData[]>([]);

    // Refs
    const lastActiveIndexRef = useRef<number>(0);
    const lastSessionRef = useRef<SessionInfo>({});
    const lastActiveSessionRef = useRef<SessionInfo[]>([]);
    const nextDateToLoadRef = useRef<string>("");

    return {
        todaySessionsRef,
        setTodaySessionsRef,
        last7SessionsRef,
        setLast7SessionsRef,
        last30SessionsRef,
        setLast30SessionsRef,
        monthlySessions,
        setMonthlySessions,
        nextDateToLoad,
        setNextDateToLoad,
        searchTerm,
        setSearchTerm,
        backupTodaySessions,
        setBackupTodaySessions,
        backupLast7Sessions,
        setBackupLast7Sessions,
        backupLast30Sessions,
        setBackupLast30Sessions,
        backupMonthlySessions,
        setBackupMonthlySessions,
        lastActiveIndexRef,
        lastSessionRef,
        lastActiveSessionRef,
        nextDateToLoadRef
    };
};
